import { CreditCardIcon } from "lucide-react";

import { cn } from "@/utils/cn";

export function CardBrandMark({
  brand,
  size = "md",
}: {
  brand: string;
  size?: "lg" | "md";
}) {
  const normalizedBrand = brand.toLowerCase();

  return (
    <span
      className={cn(
        "flex shrink-0 items-center justify-center rounded-md border border-border-secondary bg-bg-primary",
        size === "md" && "h-10 w-14.5 p-xs",
        size === "lg" && "h-16 w-23 p-md",
      )}
    >
      {normalizedBrand === "visa" && <VisaMark />}
      {normalizedBrand === "mastercard" && <MastercardMark />}
      {normalizedBrand !== "visa" && normalizedBrand !== "mastercard" && (
        <CreditCardIcon className="h-full w-full text-text-tertiary" />
      )}
    </span>
  );
}

function MastercardMark() {
  return (
    <svg
      aria-hidden="true"
      className="h-full w-full"
      fill="none"
      viewBox="0 0 48 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="19" cy="16" fill="#EB001B" r="10" />
      <circle cx="29" cy="16" fill="#F79E1B" r="10" />
      <path
        d="M24 7.34a10 10 0 0 1 0 17.32 10 10 0 0 1 0-17.32Z"
        fill="#FF5F00"
      />
    </svg>
  );
}

function VisaMark() {
  return (
    <svg
      aria-hidden="true"
      className="h-full w-full"
      fill="none"
      viewBox="8 8 77 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M28.7291 42.3798H23.2246L19.097 26.1693C18.901 25.4236 18.485 24.7644 17.8731 24.4537C16.3461 23.6729 14.6633 23.0515 12.8276 22.7381V22.114H21.6949C22.9187 22.114 23.8366 23.0515 23.9895 24.1403L26.1312 35.8335L31.633 22.114H36.9845L28.7291 42.3798ZM40.044 42.3798H34.8455L39.1262 22.114H44.3247L40.044 42.3798ZM51.0503 27.7282C51.2033 26.6367 52.1212 26.0126 53.192 26.0126C54.8747 25.8559 56.7078 26.1693 58.2375 26.9474L59.1554 22.5841C57.6256 21.96 55.9429 21.6466 54.4158 21.6466C49.3703 21.6466 45.6988 24.4537 45.6988 28.3496C45.6988 31.3134 48.2994 32.8696 50.1351 33.8071C52.1212 34.742 52.886 35.3661 52.7331 36.3009C52.7331 37.7031 51.2033 38.3272 49.6762 38.3272C47.8405 38.3272 46.0048 37.8598 44.3247 37.079L43.4069 41.445C45.2426 42.2231 47.2286 42.5365 49.0643 42.5365C54.7218 42.6905 58.2375 39.8861 58.2375 35.6768C58.2375 30.3759 51.0503 30.0652 51.0503 27.7282V27.7282ZM76.431 42.3798L72.3033 22.114H67.8697C66.9518 22.114 66.034 22.7381 65.728 23.6729L58.0846 42.3798H63.4361L64.5042 39.4187H71.0795L71.6914 42.3798H76.431ZM68.6346 27.5715L70.1617 35.2094H65.881L68.6346 27.5715Z"
        fill="#172B85"
        fillRule="evenodd"
      />
    </svg>
  );
}
